<template>
  <v-row>
    <v-col
      cols="12"
      lg="8"
      >
      <v-card
        rounded="xl"
        outlined
        >
        <v-card-title>
          CAJA GENERAL

          <v-spacer></v-spacer>

          <v-autocomplete
            v-if="false"
            :items="['Efectivo', 'Banco', 'Cheque']"
            v-model="source"
            outlined
            hide-details
            dense
            style="max-width: 200px"
            color="primary"
            ></v-autocomplete>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <balance-header
            ></balance-header>

          <template
            v-for="account in accounts"
            >
            <v-row>
              <v-col
                class="text-subtitle-1 font-weight-medium primary--text"
                cols="7"
                >
                {{ account.name }}
              </v-col>

              <v-col
                cols="2"
                class="text-subtitle-1 text-center"
                >
                ARS
              </v-col>

              <v-col
                cols="3"
                class="text-right text-subtitle-1"
                :class="account.balance >= 0 ? '' : 'red--text'"
                >
                $ {{ parseFloat(Math.abs(account.balance || 0)).toLocaleString('es-AR') }}
              </v-col>
            </v-row>
          </template>

          <v-divider></v-divider>

          <v-row>
            <v-col
              class="text-subtitle-1"
              cols="7"
              >
              Balance total
            </v-col>

            <v-col
              cols="2"
              class="text-subtitle-1"
              >
            </v-col>

            <v-col
              cols="3"
              class="text-right text-subtitle-1"
              :class="total >= 0 ? '' : 'red--text'"
              >
              $ {{ Math.abs(total).toLocaleString('es-AR') }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import BalanceHeader from './Header'

export default {
  data: () => ({
    source: 'Efectivo',
  }),

  props: {
    accounts: {
      type: Array,
      required: true
    }
  },

  components: {
    BalanceHeader
  },

  computed: {
    total () {
      let total = this.accounts.reduce( (a, b) => {
        return parseFloat(b.balance) + a
      }, 0)

      return total
    }
  }
}
</script>
